import { Box, Checkbox, Stack } from '@mui/material';
import type { BackupPolicyConfig } from '@repo/api-gw-sdk';

import BackupPolicyTag from '@/components/backupPolicy/BackupPolicyTag';

export const BackupPoliciesSelector = (props: {
  backupPolicies: BackupPolicyConfig[];
  selectedPolicies: BackupPolicyConfig[];
  setSelectedPolicies: (policies: BackupPolicyConfig[]) => void;
  showDisabledPolicies?: boolean;
}) => {
  const {
    backupPolicies,
    selectedPolicies,
    setSelectedPolicies,
    showDisabledPolicies = false,
  } = props;

  return (
    <Box
      className='px-[40px]'
      sx={{
        maxHeight: '300px',
        overflow: 'auto',
      }}
    >
      {backupPolicies
        .filter((policy) => showDisabledPolicies || policy.enabled)
        .sort((a) => (a.enabled ? -1 : 1))
        .map((policy) => (
          <Stack
            direction='row'
            alignItems='center'
            key={policy.id}
            gap='8px'
            sx={{ py: '4px' }}
          >
            <Checkbox
              value={policy.id}
              checked={selectedPolicies.some((p) => p.id === policy.id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedPolicies([...selectedPolicies, policy]);
                } else {
                  setSelectedPolicies(
                    selectedPolicies.filter((p) => p.id !== policy.id)
                  );
                }
              }}
            />
            <BackupPolicyTag policy={policy} />
          </Stack>
        ))}
    </Box>
  );
};
